{
  "title": "Mag-ulat ng pinsala sa pananim",
  "lead": "Ipaalam sa Municipal Agriculture Office kung aling mga pananim ang nasira. Nakakatulong ang ulat mo sa ayuda at kasama ito sa damage report para sa probinsya at sa Department of Agriculture.",
  "noAccountNeeded": "Hindi kailangan ng account. Unang naka-save ang ulat sa iyong telepono, kaya maipapadala mo ito kahit mahina ang signal.",
  "eventLabel": "Sakuna",
  "eventNone": "Hindi kaugnay ng sakuna",
  "farmerSection": "Tungkol sa iyo",
  "farmerName": "Buong pangalan ng magsasaka",
  "mobileHint": "Maaaring mag-text o tumawag ang opisina tungkol sa field visit.",
  "rsbsa": "RSBSA number",
  "rsbsaHint": "Opsyonal. Nakakatulong ito sa pagiging kwalipikado sa ayuda.",
  "barangay": "Barangay kung saan ang bukid",
  "plotsSection": "Mga nasirang pananim",
  "plotsHint": "Idagdag nang hiwalay ang bawat pananim o taniman.",
  "plotTitle": "Pananim {n}",
  "addPlot": "Magdagdag ng pananim o taniman",
  "removePlot": "Alisin ang pananim {n}",
  "crop": "Pananim",
  "chooseCrop": "Pumili ng pananim",
  "cropOther": "Pangalan ng pananim",
  "farmLocation": "Lokasyon ng bukid",
  "farmLocationHint": "Opsyonal. Gamitin ang iyong lokasyon habang nasa bukid ka, o i-tap ang mapa.",
  "mapLabel": "Mapa para piliin ang lokasyon ng bukid",
  "areaPlanted": "Lawak ng taniman",
  "areaAffected": "Lawak na nasira",
  "unitLegend": "Yunit ng lawak",
  "unit_sqm": "m²",
  "unit_ha": "ektarya",
  "growthStage": "Yugto ng paglaki",
  "stage_seedling": "Punla",
  "stage_vegetative": "Lumalaki",
  "stage_flowering": "Namumulaklak",
  "stage_ready_for_harvest": "Handa nang anihin",
  "extent": "Lawak ng pinsala",
  "extent_partial": "Bahagyang nasira",
  "extent_total": "Lubusang nasira",
  "cause": "Sanhi",
  "cause_typhoon": "Bagyo",
  "cause_flood": "Baha",
  "cause_landslide": "Pagguho ng lupa",
  "cause_frost": "Andap (frost)",
  "cause_hail": "Yelo (hail)",
  "cause_drought": "Tagtuyot",
  "cause_pests_disease": "Peste o sakit",
  "cause_other": "Iba pa",
  "causeOther": "Ilarawan ang sanhi",
  "damageDate": "Petsa ng pagkasira",
  "pcic": "Naka-insure ba ang pananim na ito sa PCIC?",
  "pcic_yes": "Oo",
  "pcic_no": "Hindi",
  "pcic_unknown": "Hindi sigurado",
  "photos": "Mga larawan ng pinsala",
  "loss": "Tantiyang halaga ng nawala (₱)",
  "lossHint": "Opsyonal. Puwede na ang sarili mong tantiya.",
  "submit": "Ipadala ang ulat",
  "sending": "Ipinapadala…",
  "fixErrors": "Pakitingnan ang mga naka-highlight na field.",
  "photoRequired": "Magdagdag ng kahit isang larawan ng pinsala.",
  "queuedTitle": "Na-save — ipapadala kapag may koneksyon na",
  "queuedBody": "Naka-save ang ulat mo sa teleponong ito at kusa itong ipapadala kapag may signal na. Puwede mo nang isara ang app.",
  "pendingTitle": "Naghihintay maipadala",
  "failedItem": "Hindi naipadala: {error}",
  "discard": "Alisin",
  "sendNow": "Subukang ipadala ngayon",
  "newReport": "Mag-ulat para sa ibang bukid",
  "trackTitle": "Ulat ng pinsala sa pananim",
  "reportedOn": "Iniulat noong {date}",
  "officerNote": "Paalala mula sa Agriculture Office",
  "timeline": "Mga update",
  "plotsTitle": "Ang iniulat mo",
  "affectedOf": "{affected} sa {planted} ang nasira",
  "notFound": "Hindi namin mahanap ang ulat na ito. Buksan ito mula sa link na natanggap mo pagkatapos magpadala.",
  "savedCopy": "Offline ka. Ipinapakita ang kopyang naka-save sa teleponong ito.",
  "keepLink": "Itago ang pahinang ito. Sa link nito mo masusubaybayan ang katayuan.",
  "status_submitted": "Naisumite",
  "status_for_validation": "Para sa beripikasyon",
  "status_validated": "Beripikado",
  "status_included": "Kasama sa damage report",
  "status_not_eligible": "Hindi kwalipikado",
  "statusHelp_submitted": "Natanggap ng Agriculture Office ang iyong ulat.",
  "statusHelp_for_validation": "Bibisita o kokontakin ka ng isang opisyal para suriin ang pinsala.",
  "statusHelp_validated": "Tapos na ang field visit at kumpirmado ang pinsala.",
  "statusHelp_included": "Kasama ang bukid mo sa damage report na ipinadala sa probinsya at sa DA.",
  "statusHelp_not_eligible": "Hindi naisama ang ulat na ito. Tingnan ang paalala mula sa opisina.",
  "updateNote": "Paalala",
  "promptTitle": "Naapektuhan ba ng {event} ang iyong bukid?",
  "promptBody": "Iulat ang mga nasirang pananim para maisama ka ng Agriculture Office sa damage report.",
  "promptCta": "Mag-ulat ng pinsala sa pananim",
  "myTitle": "Aking mga ulat ng pinsala sa pananim",
  "myEmpty": "Wala pang ulat ng pinsala sa pananim.",
  "plotCount": "{n} pananim",
  "plotCountOne": "1 pananim",
  "dashboardTitle": "Pinsala sa pananim",
  "dashboardLead": "Beripikahin ang mga ulat ng magsasaka at ihanda ang damage report para sa probinsya at sa DA.",
  "tabReports": "Mga ulat",
  "tabSummary": "Buod",
  "tabEvents": "Mga sakuna",
  "filterEvent": "Sakuna",
  "allEvents": "Lahat ng sakuna",
  "allBarangays": "Lahat ng barangay",
  "allCrops": "Lahat ng pananim",
  "allCauses": "Lahat ng sanhi",
  "allStatuses": "Lahat ng katayuan",
  "searchLabel": "Maghanap ng pangalan, mobile, RSBSA o reference",
  "listView": "Listahan",
  "mapView": "Mapa",
  "reportsMapLabel": "Mapa ng mga bukid sa mga nakalistang ulat",
  "noLocation": "{n} ulat na walang lokasyon ng bukid ang wala sa mapa.",
  "noReports": "Walang ulat na tugma sa mga filter na ito.",
  "noReportsYet": "Wala pang ulat ng pinsala sa pananim. Puwedeng mag-ulat ang mga magsasaka sa app anumang oras.",
  "affectedHa": "{ha} ang nasira",
  "exportCsv": "I-download ang CSV",
  "printReport": "Ulat na ipi-print",
  "exportHint": "Kasama ang mga beripikadong ulat at ang mga kasama sa damage report.",
  "rsbsaNone": "Walang RSBSA number",
  "validationTitle": "Beripikasyon",
  "officerNoteLabel": "Paalala sa magsasaka",
  "officerNoteHint": "Makikita ng magsasaka ang paalalang ito.",
  "internalNoteLabel": "Panloob na tala",
  "internalNoteHint": "Mga kawani lang ang makakakita nito.",
  "validatedArea": "Beripikadong lawak na nasira (ektarya)",
  "validatedExtent": "Beripikadong lawak ng pinsala",
  "sameAsReported": "Gaya ng iniulat",
  "saveValidation": "I-save ang beripikasyon",
  "validationSaved": "Na-save ang beripikasyon.",
  "validatedBy": "Beripikado ni {name} noong {date}",
  "reported": "Iniulat",
  "planted": "Taniman",
  "viewOnly": "Puwede mong tingnan ang mga ulat. Ang mga editor ang nagbeberipika.",
  "submittedOffline": "Na-save sa telepono noong {date}",
  "farmers": "Mga magsasaka",
  "reports": "Mga ulat",
  "haAll": "Ektaryang nasira",
  "haPartial": "Bahagyang nasira",
  "haTotal": "Lubusang nasira",
  "estLoss": "Tantiyang nawala",
  "byStatus": "Mga ulat ayon sa katayuan",
  "byCrop": "Ektaryang nasira ayon sa pananim",
  "byBarangay": "Ektaryang nasira ayon sa barangay",
  "chartNote": "Ginagamit ang beripikadong lawak kapag beripikado na ang ulat. Hindi binibilang ang mga ulat na hindi kwalipikado. Isang beses binibilang ang bawat magsasaka (ayon sa RSBSA number, o kaya mobile).",
  "showTable": "Ipakita bilang talahanayan",
  "hideTable": "Itago ang talahanayan",
  "colName": "Pangalan",
  "colPartial": "Bahagya (ha)",
  "colTotal": "Lubusan (ha)",
  "colAll": "Lahat (ha)",
  "colPlots": "Taniman",
  "colFarmers": "Magsasaka",
  "noSummary": "Wala pang binilang na ulat para dito.",
  "chooseEvent": "Pumili ng sakuna para makita ang kabuuan nito.",
  "newEvent": "Magbukas ng sakuna",
  "newEventHint": "Habang bukas ang sakuna, hinihikayat ng home screen ang mga magsasaka na mag-ulat at iniuugnay dito ang mga bagong ulat.",
  "eventName": "Pangalan",
  "eventNameHint": "Halimbawa: Bagyong ___, Okt 2026",
  "eventType": "Uri",
  "type_typhoon": "Bagyo",
  "type_flood": "Baha",
  "type_landslide": "Pagguho ng lupa",
  "type_frost": "Andap (frost)",
  "type_drought": "Tagtuyot",
  "type_earthquake": "Lindol",
  "type_other": "Iba pa",
  "startedAt": "Nagsimula noong",
  "eventNotes": "Mga tala",
  "openEvent": "Buksan ang sakuna",
  "closeEvent": "Isara ang sakuna",
  "reopenEvent": "Buksan muli",
  "eventOpened": "Nabuksan ang sakuna.",
  "eventClosed": "Naisara ang sakuna.",
  "eventReopened": "Nabuksan muli ang sakuna.",
  "closeConfirm": "Isara ang {name}? Hindi na hihikayatin ang mga magsasaka na mag-ulat para dito.",
  "active": "Bukas",
  "closed": "Sarado",
  "eventsEmpty": "Wala pang sakuna.",
  "eventMeta": "Nagsimula {date} · {n} ulat",
  "eventEnded": "Isinara {date}",
  "adminEventsTitle": "Mga sakuna",
  "adminEventsLead": "Magbukas ng sakuna habang may bagyo, baha, pagguho ng lupa o andap para hikayatin ang mga magsasaka na mag-ulat ng pinsala.",
  "printTitle": "Ulat ng pinsala sa pananim",
  "printEvent": "Sakuna: {name}",
  "printAll": "Lahat ng sakuna",
  "printGenerated": "Ginawa noong {date}",
  "printStatuses": "Kasama ang mga ulat na beripikado o kasama sa damage report.",
  "printButton": "I-print",
  "backToDashboard": "Bumalik sa pinsala sa pananim",
  "printPreparedBy": "Inihanda ni: ____________________",
  "printNotedBy": "Binigyang-pansin ni: ____________________",
  "colRef": "Reference",
  "colFarmer": "Magsasaka",
  "colRsbsa": "RSBSA",
  "colBarangay": "Barangay",
  "colCrop": "Pananim",
  "colPlanted": "Taniman (ha)",
  "colAffected": "Nasira (ha)",
  "colExtent": "Lawak",
  "colStage": "Yugto",
  "colCause": "Sanhi",
  "colDate": "Petsa ng pinsala",
  "colPcic": "PCIC",
  "colLoss": "Tantiyang nawala (₱)",
  "totals": "Kabuuan",
  "fieldRequired": "Pakipunan ito.",
  "chooseOne": "Pumili ng isa.",
  "enterNumber": "Maglagay ng numero, halimbawa 0.5.",
  "addLocation": "Idagdag ang lokasyon ng bukid",
  "hideLocation": "Itago ang mapa",
  "locationSet": "Naidagdag ang lokasyon",
  "photoHint": "Kumuha ng malinaw na larawan ng nasirang pananim. Kahit 1, hanggang 4.",
  "eventHint": "Pinagsasama-sama ang mga ulat ayon sa sakuna para sa damage report."
}
